export default class DeviceType {
  static readonly pro: string = '001'
  static readonly deep: string = '002'
  static readonly swash: string = '003'
  static readonly master: string = '004'
}

export interface DeviceInfo {
  type: string
  name: string
}

export const devices: Record<string, DeviceInfo> = {
  '001': {
    type: '001',
    name: 'CARE PRO professional',
  },
  '002': {
    type: '002',
    name: 'CARE PRO DEEP',
  },
  '003': {
    type: '003',
    name: 'CARE PRO SWaSH',
  },
  '004': {
    type: '004',
    name: 'CARE PRO Master',
  },
}

export function getDeviceInfo(deviceType: string | undefined): DeviceInfo {
  if (
    deviceType !== undefined &&
    Object.prototype.hasOwnProperty.call(devices, deviceType)
  ) {
    return devices[deviceType]
  }
  return { type: deviceType ?? '', name: '未定義' }
}
